import ImageSlider from "./ImageSlider";
import { nxmapSlides } from "../data/nxmap-slides";

export default function NxmapSlider(props) {
  const { slides, ...rest } = props || {};
  return (
    <ImageSlider
      slides={Array.isArray(slides) && slides.length > 0 ? slides : nxmapSlides}
      containerClass="max-w-6xl mx-auto"
      defaultLayout="split"
      {...rest}
    />
  );
}
